import React, { useState } from 'react'
import { Table } from 'react-bootstrap'
import BusinessAddressModalDialog from '../tx_business_components/business_address_modal_dialog'
import { openBusinessAddressModalDialog } from '../../actions/business_address_modal_dialog'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import RoundCornerIBox from './round_corner_ibox'

const Addresses = ({ onValidateClick, userTx, openBusinessAddressModalDialog, data, business }) => {
  const [selectedAddress, setSelectedAddress] = useState()

  const handleValidateClick = (address, city, state, postalCode, countyCode) => {
    if (onValidateClick) {
      onValidateClick(
        userTx.transaction_identity.first_name,
        userTx.transaction_identity.last_name,
        address,
        city,
        state,
        postalCode,
        countyCode
      )
    }
  }

  return (
    <>
      <RoundCornerIBox
        title={'Addresses'}
        icon={
          <i
            className='fa fa-plus-circle fa-2x'
            style={{ color: '#1AB293' }}
            aria-hidden='true'
            onClick={() => {
              openBusinessAddressModalDialog({ business: business.id })
              setSelectedAddress({ business: business.id })
            }}
          />
        }
      >
        <div>
          {data && data.length ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Address</th>
                  <th>Address 2</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Postal Code</th>
                  <th>Country Code</th>
                  <th>Address Type</th>
                  {onValidateClick && <th />}
                  <th>Active</th>
                </tr>
              </thead>
              <tbody>
                {data.map((entry) => (
                  <tr
                    key={entry.id}
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setSelectedAddress(entry)
                      openBusinessAddressModalDialog(entry)
                    }}
                  >
                    <td>
                      <span className={'text-link'}>{entry.address || 'N/A'}</span>
                    </td>
                    <td>{entry.unit || 'N/A'}</td>
                    <td>{entry.city}</td>
                    <td>{entry.state}</td>
                    <td>{entry.postalcode}</td>
                    <td>{entry.country_code}</td>
                    <td>{entry.address_type}</td>
                    {onValidateClick && (
                      <td>
                        <button
                          className='btn btn-default'
                          onClick={() =>
                            handleValidateClick(
                              entry.address,
                              entry.city,
                              entry.state,
                              entry.postalcode,
                              entry.country_code
                            )
                          }
                        >
                          Validate the address
                        </button>
                      </td>
                    )}
                    <td>{entry.is_active ? 'Yes' : 'No'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <span>{'N/A'}</span>
          )}
        </div>
      </RoundCornerIBox>
      {selectedAddress && (
        <BusinessAddressModalDialog
          business={business}
          data={selectedAddress}
          onHide={() => setSelectedAddress(null)}
        />
      )}
    </>
  )
}
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openBusinessAddressModalDialog,
    },
    dispatch
  )

export default withRouter(connect(null, mapDispatchToProps)(Addresses))
